import { GenericResponse } from 'services/api/base';
import { MatrizChuvaObservada } from 'types/Relatorios/Matriz';

// eslint-disable-next-line import/prefer-default-export
export const transformMatrizChuvaObservadaResponse = (
  response: GenericResponse<MatrizChuvaObservada>,
): MatrizChuvaObservada => response.data;
